import { LatLngLiteral } from '@googlemaps/google-maps-services-js';
import { createFeature, createReducer, on } from '@ngrx/store';
import { ProjectServiceCreateResponseJson } from '@vmspdb/definitions';
import { PaginatedProjectActions } from './paginated-project.actions';

export const paginatedProjectFeatureKey = 'paginatedProject';

export interface PaginatedProjectState {
  items: ProjectServiceCreateResponseJson[];
  loading: boolean;
  total: number;
  page: number;
  error: any;
  refGeoPoint: LatLngLiteral | undefined;
}

export const initialState: PaginatedProjectState = {
  items: [],
  total: 0,
  page: 0,
  loading: false,
  error: undefined,
  refGeoPoint: undefined,
};

export const reducer = createReducer(
  initialState,
  on(
    PaginatedProjectActions.listPaginatedProjects,
    (state): PaginatedProjectState => ({ ...state, loading: true }),
  ),
  on(
    PaginatedProjectActions.listPaginatedProjectsSuccess,
    (state, { data }): PaginatedProjectState => ({
      ...state,
      ...data,
      ...data.pagination,
      total: Number(data.pagination?.total),
      loading: false,
    }),
  ),
  on(
    PaginatedProjectActions.listPaginatedProjectsFailure,
    (state, { error }): PaginatedProjectState => ({
      ...state,
      error,
      loading: false,
    }),
  ),
  on(
    PaginatedProjectActions.setRefGeopoint,
    (state, { refGeoPoint }): PaginatedProjectState => ({
      ...state,
      refGeoPoint,
    }),
  ),
);

export const paginatedProjectFeature = createFeature({
  name: paginatedProjectFeatureKey,
  reducer,
});
